<template>
  <v-data-table
    v-scroll:#data-section="onScroll"
    :headers="headers"
    :items="companiesToShow"
    :disable-pagination="true"
    :custom-sort="sortData"
    :hide-default-footer="true"
    :must-sort="true"
    sortBy="displayName"
    item-key="_id"
    class="data-table elevation-0"
    :mobile-breakpoint="0"
    @click:row="selectRow"
  >
    <template v-slot:item.displayName="{ item }">
      <div class="sdg-patch-container">
        <div
          v-for="sdg in item.data.sdg"
          :key="item.data.project_id + sdg"
          :sdg="sdg"
          :style="{backgroundColor: sdgByCode[sdg].color}"
          :title="sdgByCode[sdg].text"
          class="patch"
        />
      </div>
      {{ item.displayName }}
    </template>
    <template
      v-slot:item.data._consolidatedFinRevenueRange="{ item }"
    >{{ formatRevenueRange(item.data._consolidatedFinRevenueRange) }}</template>
    <template
      v-slot:item.data._consolidatedEmployeeRange="{ item }"
    >{{ formatEmployeeRange(item.data._consolidatedEmployeeRange) }}</template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import format from '@/helpers/format'
import optionsData from '@/data/options'

export default {
  name: 'data-table',
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'displayName',
          width: 114,
          class: 'name-col',
        },
        { text: 'Country', value: 'data.baseCountry', width: 57 },
        { text: 'Sector', value: 'data.sector', width: 82 },
        {
          text: 'Employees',
          value: 'data._consolidatedEmployeeRange',
          width: 58,
        },
        {
          text: 'Revenue',
          value: 'data._consolidatedFinRevenueRange',
          width: 85,
        },
      ],
      rowsNumber: 20,
      sort: {
        by: 'displayName',
        isDesc: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      companies: 'companies/inBoundsCompanies',
    }),
    sdgByCode() {
      return optionsData.sdgOptions.reduce((acc, item) => {
        acc[item.code] = item
        return acc
      }, {})
    },
    companiesToShow() {
      const copy = [].concat(this.companies)
      const sortBy = this.sort.by
      const isDesc = this.sort.isDesc
      const res = copy.sort((a, b) => {
        const first = get(a, sortBy)
        const second = get(b, sortBy)
        if (isDesc) {
          if (second === undefined) {
            return 1
          }
          return second > first ? 1 : -1
        } else {
          if (first === undefined) {
            return 1
          }
          return first > second ? 1 : -1
        }
      }).slice(0, this.rowsNumber)
      return res
    },
  },
  methods: {
    ...mapActions({
      setCard: 'map/setCard',
    }),
    selectRow(v) {
      const data = Object.assign({}, v)
      data.kind = 'company'
      this.setCard(data)
      const desktopWidth = 1024
      if (window.innerWidth < desktopWidth) {
        this.$vuetify.goTo('#map-section')
      }
    },
    formatRevenueRange(value) {
      return format.getRevenueRange(value)
    },
    formatEmployeeRange(value) {
      return format.getEmployeeRange(value)
    },
    onScroll(e) {
      const el = e.target
      if (Math.abs(el.scrollTop - el.scrollHeight + el.offsetHeight) < 1) {
        if (this.companies.length > this.rowsNumber) {
          this.rowsNumber += 20
        }
      }
    },
    sortData(items, sortBy, isDesc) {
      this.sort.by = sortBy[0]
      this.sort.isDesc = isDesc[0]
      return items
    }
  },
}
</script>

<style lang="scss" scoped>
.data-table ::v-deep tbody tr {
  cursor: pointer;
  border: none;
  &:nth-child(odd) {
    background-color: #f4f5fa;
  }
}
.data-table ::v-deep th {
  padding: 0 3px;
  white-space: nowrap;
  border-bottom: none !important;
}
.data-table ::v-deep tbody td {
  font-size: 12px;
  padding: 10px 3px;
  border-bottom: none !important;
  position: relative;
  vertical-align: top;
}
.data-table ::v-deep {
  & th,
  & td {
    &:first-child {
      padding-left: 34px;
    }
    &:last-child {
      padding-right: 34px;
    }
  }
}
.data-table ::v-deep tbody tr :first-child {
  font-weight: bold;
}
.sdg-patch-container {
  position: absolute;
  left: 20px;
  top: 16px;
  bottom: 6px;
  overflow: hidden;
  .patch {
    width: 6px;
    height: 6px;
    margin-bottom: 3px;
  }
}
</style>
